import { http } from 'services';

export const List = () => http.request.get('/api/v1/client/useful/list');